import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { searchTranslationRef } from '@backstage/plugin-search/alpha';

export const searchFr = createTranslationMessages({
  ref: searchTranslationRef,
  full: true,
  messages: {
    'searchModal.viewFullResults': 'Voir tous les résultats',
    'searchType.tabs.allTitle': 'Tout',
    'searchType.allResults': 'Tous les résultats',
    'searchType.accordion.collapse': 'Réduire',
    'searchType.accordion.numberOfResults': '{{number}} résultats',
    'searchType.accordion.allTitle': 'Tout',
    'sidebarSearchModal.title': 'Recherche',
  },
});
